var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.667 4.167a2.5 2.5 0 0 1 2.5-2.5h6.666a2.5 2.5 0 0 1 2.5 2.5v2.5h2.5a2.5 2.5 0 0 1 2.5 2.5v6.666a2.5 2.5 0 0 1-2.5 2.5H9.167a2.5 2.5 0 0 1-2.5-2.5v-2.5h-2.5a2.5 2.5 0 0 1-2.5-2.5zm10.416 2.5H9.167a2.5 2.5 0 0 0-2.5 2.5v2.916h-2.5a1.25 1.25 0 0 1-1.25-1.25V4.167c0-.691.559-1.25 1.25-1.25h6.666c.691 0 1.25.559 1.25 1.25z",
    clipRule: "evenodd"
  })));
};
export default SvgCopy;